import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotificationsService } from './notifications.service';

/**
 * After a successful write to a service entity (proto, labdip, bulk, sourcing,
 * trim, print-embroidery), refresh the notifications feed so the bell reflects
 * the group-wide dismissal performed server-side — without waiting for the
 * 60s poll.
 *
 * Keeps GETs and write-to-notifications endpoints out of the trigger to avoid
 * loops.
 */
const SERVICE_WRITE_PATH = /\/api\/(protos|labdips|bulks|sourcing|trims|print-embroidery)\b/i;
const NOTIFICATIONS_PATH = /\/api\/notifications\b/i;

@Injectable()
export class NotificationsRefreshInterceptor implements HttpInterceptor {
  constructor(private notifications: NotificationsService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isWrite = req.method !== 'GET' && req.method !== 'HEAD' && req.method !== 'OPTIONS';
    const touchesService =
      isWrite && SERVICE_WRITE_PATH.test(req.url) && !NOTIFICATIONS_PATH.test(req.url);

    const handled = next.handle(req);
    if (!touchesService) return handled;

    return handled.pipe(
      tap((event) => {
        if (event instanceof HttpResponse && event.status >= 200 && event.status < 300) {
          this.notifications.scheduleRefresh();
        }
      })
    );
  }
}
